import angular from 'angular';
import uiRouter from 'angular-ui-router';
import cardRequestDaysComponent from './cardRequestDays.component';

let cardRequestDaysModule = angular.module('cardRequestDays', [
  uiRouter
])

.component('cardRequestDays', cardRequestDaysComponent)

.name;

export default cardRequestDaysModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/userCardList/userCardRow/homeCard/cardRequestDays/cardRequestDays.js